import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f008f8c4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "caizhongpeizhi"
};
const _hoisted_2 = {
  key: 0,
  class: "panel-title"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "彩种配置", -1));

const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  class: "panel-body"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "彩种选择", -1));

const _hoisted_7 = {
  class: "item"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存选择");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_divider = _resolveComponent("el-divider");

  const _component_el_checkbox = _resolveComponent("el-checkbox");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass($data.show_panel ? 'panel' : '')
  }, [$data.show_panel ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "content"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_list, item => {
      return _openBlock(), _createBlock(_component_el_col, {
        key: item.id,
        span: $data.user == '' ? 12 : 8
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [$data.user == '' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          modelValue: item.order,
          "onUpdate:modelValue": $event => item.order = $event,
          placeholder: Boolean(item.status * 1) ? '请输入排序' : '',
          type: "number",
          clearable: "",
          disabled: item.status == 0
        }, {
          prepend: _withCtx(() => [_createVNode(_component_el_checkbox, {
            style: {
              "width": "100px"
            },
            label: item.gname,
            checked: item.status == 1,
            onChange: $event => $options.chageGameStatus(item)
          }, null, 8, ["label", "checked", "onChange"])]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])) : (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 1,
          border: "",
          label: item.gname,
          checked: item.status == 1,
          onChange: $event => $options.chageGameStatus(item)
        }, null, 8, ["label", "checked", "onChange"]))])]),
        _: 2
      }, 1032, ["span"]);
    }), 128))]),
    _: 1
  })]), _createVNode(_component_el_button, {
    size: "small",
    style: {
      "margin-top": "10px"
    },
    type: "warning",
    onClick: $options.save_list
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }, 8, ["onClick"])], 2)]);
}